
<br />
<div class="center" *ngIf="!requestsCompleted">
  <app-calibrant-load [small]="true"></app-calibrant-load>
</div>

<div *ngIf="requestsCompleted">
  <div class="flex items-center justify-between">
    <h3 class="title-header">Dispatches</h3>
    <button mat-flat-button color="primary" #button (click)="addDispatch(button)">Add Dispatch</button>
  </div>
  <br />
  <br />
  <hr />
</div>
<br />
<div class="mat-elevation-z8" matSort *ngIf="requestsCompleted">
  <table *ngIf="dataSource" mat-table [dataSource]="dataSource" style="width: 100%;">
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td mat-cell *matCellDef="let element">
        <span class="font-weight-bold">
          {{element.dispatch.status}}
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="programName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Program Name</th>
      <td mat-cell *matCellDef="let element">
        <a routerLink="/program/{{getDispatchProgram(element.dispatch).id}}/view">{{element.programName}}</a>
      </td>
    </ng-container>
    <ng-container matColumnDef="setpoint">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Set Point</th>
      <td mat-cell *matCellDef="let element">{{cleanNumericInput(element, 'setpoint')}} kW</td>
    </ng-container>
    <ng-container matColumnDef="incentive">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Incentive </th>
      <td mat-cell *matCellDef="let element">{{cleanNumericInput(element, 'incentive')}} $/kW</td>
    </ng-container>
    <ng-container matColumnDef="penalty">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Penalty</th>
      <td mat-cell *matCellDef="let element">{{cleanNumericInput(element, 'penalty')}} $/kW</td>
    </ng-container>
    <ng-container matColumnDef="startTimeUtc">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Time</th>
      <td mat-cell *matCellDef="let element">{{element.startTimeUtc | date: dateFormatStr}} UTC</td>
    </ng-container>
    <ng-container matColumnDef="endTimeUtc">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>End Time</th>
      <td mat-cell *matCellDef="let element">{{element.endTimeUtc | date: dateFormatStr}} UTC</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[5, 10, 20, 50]"
                 showFirstLastButtons
                 [pageSize]="pageSize"
                 [pageIndex]="0"
                 aria-label="Select from dispatch list.">
  </mat-paginator>
</div>
